import { CHAT, websocketapp, setRecevieHelmetStatus } from '@/common/websocket/index'
import { success, warning, getSession } from '@/api/common'
import Vue from 'vue'
import store from '@/store/index'
import { operations } from '@/api/log/operation'
import i18n from '@/common/i18n'

/**
 * 遥控动作常量
 */
const ACTION = {
  /**
   * 关闭 GPS
   */
  GPS_CLOSE: '1,0',
  /**
   * 打开 GPS
   */
  GPS_OPEN: '1,1',
  /**
   * 关闭 LED 照明
   */
  LED_CLOSE: '3,0',
  /**
   * 打开 LED 照明
   */
  LED_OPEN: '3,1',
  /**
   * 关闭 录像
   */
  VIDICON_CLOSE: '7,0',
  /**
   * 打开 录像
   */
  VIDICON_OPEN: '7,1',
  /**
   * 关闭 激光
   */
  LASER_CLOSE: '12,0',
  /**
   * 打开 激光
   */
  LASER_OPEN: '12,1',
  /**
   * 关闭 重要录像
   */
  IMP_CLOSE: '14,0',
  /**
   * 打开 重要录像
   */
  IMP_OPEN: '14,1',
  /**
   * 拍照
   */
  PHOTO_OPEN: '15,0',
  /**
   * 关闭 热点
   */
  HOT_POINT_CLOSE: '16,0',
  /**
   * 打开 热点
   */
  HOT_POINT_OPEN: '16,1',
  /**
   * 关闭 WIFI
   */
  WIFI_CLOSE: '17,0',
  /**
   * 打开 WIFI
   */
  WIFI_OPEN: '17,1',
  /**
   * 关闭 警示灯
   */
  WARNLIGHT_CLOSE: '19,0',
  /**
   * 打开 警示灯
   */
  WARNLIGHT_OPEN: '19,1',
  /**
   * 关闭 警示灯声音
   */
  WARNLIGHT_VOICE_CLOSE: '20,0',
  /**
   * 打开 警示灯声音
   */
  WARNLIGHT__VOICE_OPEN: '20,1',
}

// 记录上一个动作状态
let last_action = null

/**
 * 遥控器相关
 */
// 自定义响应处理
setRecevieHelmetStatus(recevieHelmetStatus)
/**
 * 接收安全帽状态
 * @param {*} receiveMsg
 * @param {*} receiveParams
 */
function recevieHelmetStatus(receiveMsg, receiveParams) {
  // 录像提示音等属性对象
  if (receiveParams.status.slice(2, 7) === 'frame') {
    // console.log(receiveParams)
    let vidiconObj = JSON.parse(receiveParams.status)
    store.commit('changeVidiconObj', vidiconObj)
  }
  // 遥控器相关操作
  else {
    let helmetId = receiveMsg.header.from
    // HelmetStatusObj 属性为安全帽的helmetId 值为ws返回的status的值
    let HelmetStatusObj = store.state.helmetStatusObj
    // 状态格式转换
    //
    receiveParams.status = handleData(receiveParams.status)
    // console.log('遥控器相关操作',last_action,receiveParams.status)
    if (last_action) {
      switch (last_action) {
        case ACTION.GPS_CLOSE:
          if (receiveParams.status.GPS === '0') {
            success(i18n.t('InterfacePrompt.0'))
          } else {
            warning(i18n.t('operationNotSupported'))
          }
          break
        case ACTION.GPS_OPEN:
          if (receiveParams.status.GPS !== '0') {
            success(i18n.t('InterfacePrompt.0'))
          } else {
            warning(i18n.t('operationNotSupported'))
          }
          break
        case ACTION.LED_CLOSE:
          if (receiveParams.status.LED === '0') {
            success(i18n.t('InterfacePrompt.0'))
          } else {
            warning(i18n.t('operationNotSupported'))
          }
          break
        case ACTION.LED_OPEN:
          if (receiveParams.status.LED !== '0') {
            success(i18n.t('InterfacePrompt.0'))
          } else {
            warning(i18n.t('operationNotSupported'))
          }
          break
        case ACTION.VIDICON_CLOSE:
          if (receiveParams.status.vidicon === '0') {
            success(i18n.t('InterfacePrompt.0'))
          } else {
            warning(i18n.t('operationNotSupported'))
          }
          break
        case ACTION.VIDICON_OPEN:
          if (receiveParams.status.vidicon !== '0') {
            success(i18n.t('InterfacePrompt.0'))
          } else {
            warning(i18n.t('operationNotSupported'))
          }
          break
        case ACTION.LASER_CLOSE:
          if (receiveParams.status.laser === '0') {
            success(i18n.t('InterfacePrompt.0'))
          } else {
            warning(i18n.t('operationNotSupported'))
          }
          break
        case ACTION.LASER_OPEN:
          if (receiveParams.status.laser !== '0') {
            success(i18n.t('InterfacePrompt.0'))
          } else {
            warning(i18n.t('operationNotSupported'))
          }
          break
        case ACTION.IMP_CLOSE:
          if (receiveParams.status.imp === '0') {
            success(i18n.t('InterfacePrompt.0'))
          } else {
            warning(i18n.t('operationNotSupported'))
          }
          break
        case ACTION.IMP_OPEN:
          if (receiveParams.status.imp !== '0') {
            success(i18n.t('InterfacePrompt.0'))
          } else {
            warning(i18n.t('operationNotSupported'))
          }
          break
        case ACTION.PHOTO_OPEN:
          if (receiveParams.status.photo === '0') {
            success(i18n.t('InterfacePrompt.0'))
          } else {
            warning(i18n.t('operationNotSupported'))
          }
          break
        case ACTION.HOT_POINT_CLOSE:
          if (receiveParams.status.hotPoint === '0') {
            success(i18n.t('InterfacePrompt.0'))
          } else {
            warning(i18n.t('operationNotSupported'))
          }
          break
        case ACTION.HOT_POINT_OPEN:
          if (receiveParams.status.hotPoint !== '0') {
            success(i18n.t('InterfacePrompt.0'))
          } else {
            warning(i18n.t('operationNotSupported'))
          }
          break
        case ACTION.WIFI_CLOSE:
          if (receiveParams.status.WIFI === '0') {
            success(i18n.t('InterfacePrompt.0'))
          } else {
            warning(i18n.t('operationNotSupported'))
          }
          break
        case ACTION.WIFI_OPEN:
          if (receiveParams.status.WIFI !== '0') {
            success(i18n.t('InterfacePrompt.0'))
          } else {
            warning(i18n.t('operationNotSupported'))
          }
          break
        case ACTION.WARNLIGHT_CLOSE:
          if (receiveParams.status.warnlight === '0') {
            success(i18n.t('InterfacePrompt.0'))
          } else {
            warning(i18n.t('operationNotSupported'))
          }
          break
        case ACTION.WARNLIGHT_OPEN:
          if (receiveParams.status.warnlight !== '0') {
            success(i18n.t('InterfacePrompt.0'))
          } else {
            warning(i18n.t('operationNotSupported'))
          }
          break
        default:
          break
      }
      last_action = null
    }
    Vue.set(HelmetStatusObj, helmetId, receiveParams.status)
  }
}
/**
 * 处理安全帽状态码数据
 * @param {*} status 安全帽状态码
 * @returns
 */
function handleData(status) {
  let statusArr = status.split(';')
  let statusObj = {}
  statusObj['power'] = statusArr[0].split(',')[1]
  statusObj['GPS'] = statusArr[1].split(',')[1]
  // 非wifi网络信号（4g）
  statusObj['networkSignal'] = statusArr[2].split(',')[1]
  statusObj['phoneSign'] = statusArr[2].split(',')[2]
  let ledObj = statusArr[3].split(',')
  statusObj['LED'] = ledObj[1]
  if (ledObj && ledObj.length > 2) {
    statusObj['LEDRank'] = ledObj[2]
  } else {
    statusObj['LEDRank'] = 175
  }
  statusObj['vidicon'] = statusArr[6].split(',')[1]
  statusObj['rfid'] = statusArr[7].split(',')[1]
  statusObj['laser'] = statusArr[8].split(',')[1]
  statusObj['imp'] = statusArr[10].split(',')[1]
  statusObj['photo'] = statusArr[11].split(',')[1]
  statusObj['hotPoint'] = statusArr[12].split(',')[1]
  statusObj['WIFI'] = statusArr[13].split(',')[1]
  statusObj['read'] = statusArr[14].split(',')[1]
  statusObj['warnlight'] = statusArr[15].split(',')[1]
  statusObj['warnlightVoice'] = statusArr[16].split(',')[1]

  // websocket中回传的key值非连续，存在断号的情况，如下所示
  // 0,56; 1,0; 2,0,4; 3,0;4,7;5,0;7,0;8,0;12,0;13,-1;14,0;15,0;16,0;17,4;18,0,255;19,0;20,1;21,69;22,0;23,0;
  // 后续应将索引获取值的方式替换为通过startsWith判断
  statusArr.forEach(s => {
    // 23,0   0代表脱帽，1代表戴帽
    if (s.startsWith('23,')) {
      statusObj['wearing'] = s.split(',')[1] === '1'
    } else if (s.startsWith('24,')) {
      statusObj['deviceMode'] = s.split(',')[1]
    }
  })

  return statusObj
}

/**
 * 获取初始开关状态
 * @param {*} serialNumber 安全帽序列号
 */
function initSwitch(serialNumber) {
  var sendMsg = {
    operationType: 'operation',
    operationCode: '-1', //查询安全帽状态，此时msg一定是"operation","-1"
  }
  CHAT.chat(websocketapp.CONTROL, serialNumber, sendMsg)
}

/**
 * 开关发送指令
 * @param {*} serialNumber 安全帽序列号
 * @param {*} operationCode 操作码,遥控动作常量
 * @see 遥控动作常量: {@link ACTION}
 */
function switchAction(serialNumber, operationCode, userId, inforUserName) {
  // 如果动作为拍照，将拍照状态置为1，拍照中
  if (operationCode === ACTION.PHOTO_OPEN) {
    store.commit('changeHelmetPhotoStatusOn', serialNumber)
  }
  var sendMsg = {
    operationType: 'operation',
    operationCode: operationCode,
  }
  CHAT.chat(websocketapp.CONTROL, serialNumber, sendMsg)
  last_action = operationCode
  // 状态码第一个数字代表类型
  let childOperation = operationCode.split(',')[0]
  // 状态码第二个数字代表开关状态
  let event = operationCode.split(',')[1]
  if (event !== '0') {
    event = -1
  }
  let param = [
    {
      childOperation: childOperation,
      event: event,
      logTimestamp: new Date().format('yyyy-MM-dd hh:mm:ss'),
      loginUserName: getSession('username'),
      operation: '远程控制',
      remoteHelmetId: serialNumber,
      remoteUserId: userId,
      remoteUserName: inforUserName,
      // operationIp: getSession('localIp')
    },
  ]
  operations(param)
}
/**
 * 录像详情发送指令
 * @param {*} serialNumber 安全帽序列号
 * @param {*} operationCode 操作码,遥控动作常量
 * @see 遥控动作常量: {@link ACTION}
 */
function videoSetting(serialNumber, operationCode) {
  var sendMsg = {
    operationType: 'videoSetting',
    operationCode: operationCode,
  }
  CHAT.chat(websocketapp.CONTROL, serialNumber, sendMsg)
}
/**
 * led灯光亮度等级发送指令
 * @param {*} serialNumber 安全帽序列号
 * @param {*} operationCode 操作码,遥控动作常量
 * @see 遥控动作常量: {@link ACTION}
 */
function ledSetting(serialNumber, operationCode) {
  var sendMsg = {
    operationType: 'ledSetting',
    operationCode: operationCode,
  }
  CHAT.chat(websocketapp.CONTROL, serialNumber, sendMsg)
}

export { ACTION, initSwitch, switchAction, videoSetting, ledSetting }
